<div class="modal-header">
  <h4 class="modal-title">Configure Report Columns</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" style="overflow-y: auto; max-height: calc(100vh - 12rem);">

  <div class="border-rounded-10 mb-2 px-2 py-2"
       *ngFor="let col of columns; let idx = index; let first = first; let last = last;">
    <div class="float-right">
      <button class="btn btn-secondary btn-sm mr-1 my-auto"
              title="Move To Top"
              [disabled]="first"
              [class.disabled]="first"
              (click)="shiftColumnToExtreme(idx, true)">
        &uarr;&uarr;
      </button>
      <button class="btn btn-secondary btn-sm mr-1"
              title="Move Up 1"
              [disabled]="first"
              [class.disabled]="first"
              (click)="shiftColumnByOne(idx, true)">
        &uarr;
      </button>
      <button class="btn btn-secondary btn-sm mr-1"
              title="Move Down 1"
              [disabled]="last"
              [class.disabled]="last"
              (click)="shiftColumnByOne(idx, false)">
        &darr;
      </button>
      <button class="btn btn-secondary btn-sm mr-1"
              title="Move To Bottom"
              [disabled]="last"
              [class.disabled]="last"
              (click)="shiftColumnToExtreme(idx, false)">
        &darr;&darr;
      </button>
      <button class="btn btn-danger btn-sm"
              title="Remove Column"
              (click)="removeColumn(idx)">
        X
      </button>
    </div>
    <p class="column-name">
      {{ columnHeaderOverrides[col] || col }}
      <ng-container *ngIf="columnHelpText[col]">
        <br>
        <small class="text-muted"
               style="margin-top: -3px;">
          {{ columnHelpText[col] }}
        </small>
      </ng-container>
    </p>
  </div>

  <hr>

  <div class="border-rounded-10 mb-2 px-2 py-2"
       *ngFor="let col of availableColumns()">
    <div class="float-right">
      <button class="btn btn-success btn-sm"
              title="Add Column"
              (click)="addColumn(col)">
        Add Column
      </button>
    </div>
    <p class="column-name">
      {{ columnHeaderOverrides[col] || col }}
      <ng-container *ngIf="columnHelpText[col]">
        <br>
        <small class="text-muted"
               style="margin-top: -3px;">
          {{ columnHelpText[col] }}
        </small>
      </ng-container>
    </p>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-outline-primary float-left"
          (click)="handleSelectDefault()">
    Restore Defaults
  </button>

  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="columns.length === 0"
          [class.disabled]="columns.length === 0"
          (click)="handleSubmit()">
    Submit
  </button>
</div>
